/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const companiesRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '拆迁公司',
        path: 'companies',
        component: () => import('@/views/companies/List'),
      },
      // {
      //   name: '建设主体详情',
      //   path: 'companies/:id',
      //   component: () => import('@/views/companies/Details'),
      // },
    ],
  }
  
  export default companiesRouter
  
  
  
  